<template>
  <div class="landing-page-senior">
    <!-- Importar Fontes Google -->
    <link
      href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;1,400&family=Mulish:wght@300;400;700&display=swap"
      rel="stylesheet"
    />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

    <!-- Header -->
    <header class="senior-header">
      <div class="logo-container">
        <a href="#">
          <img src="@/assets/images/Ativo 3logo 1.png" alt="Logo Sênior Shopping" class="logo-img" />
        </a>
      </div>
      <nav>
        <a href="#sobre">Sobre</a>
        <a href="#servicos">Serviços</a>
        <a href="#anunciar" class="btn-nav" @click.prevent="goToLogin">Anunciar</a>
      </nav>
    </header>

    <!-- Hero Section -->
    <section class="senior-parallax-hero">
      <div class="senior-overlay"></div>
      <div class="senior-hero-content">
        <h1>Cuidado que orienta.<br />Curadoria que acolhe.</h1>
        <p>A plataforma mais segura do Brasil para conectar você a serviços de longevidade.</p>
        <br />
        <a href="#" class="btn-cta" @click.prevent="goToHome">Encontrar Serviços</a>
      </div>
    </section>

    <!-- Intro Section -->
    <section class="senior-intro-section" id="sobre">
      <h2>Simplicidade é o novo luxo.</h2>
      <p>
        Criamos um ambiente onde encontrar ajuda especializada não é um problema, mas uma solução tranquila. Navegue
        com clareza, encontre com segurança e decida com confiança.
      </p>
    </section>

    <!-- Parallax Divider (Segurança) -->
    <section class="senior-parallax-divider">
      <div class="senior-glass-card">
        <div class="senior-security-icon">
          <i class="fa-solid fa-shield-halved"></i>
        </div>
        <h3>Sua segurança é nossa prioridade</h3>
        <p>
          Analisamos criteriosamente antecedentes e qualificações de cada profissional e empresa parceira.
          <br />
          <strong>Aqui, você encontra cuidado com total tranquilidade.</strong>
        </p>
      </div>
    </section>

    <!-- Services Section -->
    <section class="senior-services-section" id="servicos">
      <div class="senior-cards-wrapper">
        <div class="senior-service-card">
          <i class="fa-solid fa-user-nurse senior-icon-box" style="color: #82a097"></i>
          <h3>Saúde & Cuidado</h3>
          <p>Enfermeiros, cuidadores e fisioterapeutas especializados no público sênior.</p>
        </div>
        <div class="senior-service-card">
          <i class="fa-solid fa-couch senior-icon-box" style="color: #cba34b"></i>
          <h3>Conforto em Casa</h3>
          <p>Adaptações, móveis ergonômicos e tecnologia assistiva para o lar.</p>
        </div>
        <div class="senior-service-card">
          <i class="fa-solid fa-plane-departure senior-icon-box" style="color: #4a6faf"></i>
          <h3>Lazer & Social</h3>
          <p>Viagens em grupo, cursos e atividades para manter a mente ativa.</p>
        </div>
      </div>
    </section>

    <!-- Pricing Section (Anunciar) -->
    <section class="senior-pricing-section" id="anunciar">
      <div class="senior-pricing-header">
        <h2>Anuncie com credibilidade no público 60+</h2>
        <p>
          Um portal com curadoria, ambiente confiável e foco total em qualidade. Planos simples, com parcelamento e
          total bem claro, para você começar sem complicação.
        </p>
      </div>

      <div class="senior-pricing-grid">
        <!-- PLANO MENSAL -->
        <div class="senior-plan-card">
          <div class="senior-plan-top">
            <div class="senior-plan-name">Plano Mensal</div>
            <div class="senior-badge">Flexível</div>
          </div>

          <div class="senior-price-line">
            <div class="senior-price-main">R$ 199</div>
            <div class="senior-price-suffix">/ mês</div>
          </div>

          <div class="senior-total-line">
            <span class="senior-total-pill">Sem fidelidade • cancele quando quiser</span>
          </div>

          <ul class="senior-plan-features">
            <li><i class="fa-solid fa-check"></i> Anúncio com foto</li>
            <li><i class="fa-solid fa-check"></i> Botão de WhatsApp direto</li>
            <li><i class="fa-solid fa-check"></i> Suporte via e-mail/chat</li>
            <li><i class="fa-solid fa-check"></i> Acesso a métricas de visualização (a combinar)</li>
          </ul>

          <a class="senior-plan-cta" href="#contato" @click.prevent="goToLogin">Quero anunciar</a>
        </div>

        <!-- PLANO SEMESTRAL -->
        <div class="senior-plan-card">
          <div class="senior-plan-top">
            <div class="senior-plan-name">Plano Semestral</div>
            <div class="senior-badge">Equilibrado</div>
          </div>

          <div class="senior-price-line">
            <div class="senior-price-main">R$ 179</div>
            <div class="senior-price-suffix">/ mês (6x)</div>
          </div>

          <div class="senior-total-line">
            <span class="senior-total-pill">Total do período: R$ 1.074</span>
          </div>

          <div class="senior-save-line">
            Em relação ao mensal: <span class="senior-strike">R$ 1.194</span> → paga menos no total.
          </div>

          <ul class="senior-plan-features">
            <li><i class="fa-solid fa-check"></i> Anúncio com foto</li>
            <li><i class="fa-solid fa-check"></i> Botão de WhatsApp direto</li>
            <li><i class="fa-solid fa-check"></i> Suporte via e-mail e chat</li>
            <li><i class="fa-solid fa-check"></i> Acesso a métricas de visualização (a combinar)</li>
            <li><i class="fa-solid fa-check"></i> Acesso a métricas de desempenho (a combinar)</li>
          </ul>

          <a class="senior-plan-cta" href="#contato" @click.prevent="goToLogin">Quero anunciar</a>
        </div>

        <!-- PLANO ANUAL (DESTAQUE) -->
        <div class="senior-plan-card senior-best">
          <div class="senior-plan-top">
            <div class="senior-plan-name">Plano Anual</div>
            <div class="senior-badge senior-badge-best">Mais vantajoso</div>
          </div>

          <div class="senior-price-line">
            <div class="senior-price-main">R$ 169</div>
            <div class="senior-price-suffix">/ mês (12x)</div>
          </div>

          <div class="senior-total-line">
            <span class="senior-total-pill">Total do período: R$ 2.028</span>
          </div>

          <div class="senior-save-line">
            Em relação ao mensal: <span class="senior-strike">R$ 2.388</span> → economia no total.
          </div>

          <ul class="senior-plan-features">
            <li><i class="fa-solid fa-check"></i> Anúncio com foto</li>
            <li><i class="fa-solid fa-check"></i> Botão de WhatsApp direto</li>
            <li><i class="fa-solid fa-check"></i> Suporte prioritário via e-mail e chat</li>
            <li><i class="fa-solid fa-check"></i> Acesso completo a métricas e relatórios personalizados (a combinar)</li>
          </ul>

          <a class="senior-plan-cta" href="#contato" @click.prevent="goToLogin">Anunciar agora</a>
        </div>
      </div>

      <div class="senior-pricing-note">
        <strong>Extras (opcional):</strong> banners e destaques do portal podem ser adicionados ao plano conforme
        disponibilidade e objetivo da campanha.
      </div>
    </section>

    <!-- Footer -->
    <footer class="senior-footer" id="contato">
      <h2>Vamos começar?</h2>
      <p style="font-size: 1.4rem; max-width: 600px; margin: 0 auto 40px; opacity: 0.9">
        Encontre o que precisa ou anuncie seus serviços para quem procura qualidade.
      </p>
      <a href="#contato" class="senior-btn-footer" @click.prevent="openWhatsApp">Fale Conosco</a>
      <div class="senior-footer-links">&copy; 2025 Sênior Shopping Brasil. Todos os direitos reservados.</div>
    </footer>
  </div>
</template>

<script>
import api from "@/services/api";
export default {
  name: 'LandingPage',
  data() {
    return {
      enterprisePhone: null,
    };
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    goToHome() {
      this.$router.push('/app-home');
    },
    sanitizePhone(phone) {
      if (!phone) return "";
      return String(phone).replace(/\D/g, "");
    },
    async getEnterpriseData() {
      try {
        const response = await api.get("/enterprise/home");
        const enterprise = response.data?.data?.[0] || {};
        this.enterprisePhone = enterprise.phone || null;
      } catch (error) {
        console.error("Erro ao carregar dados da empresa:", error);
      }
    },
    openWhatsApp() {
      if (!this.enterprisePhone) return;

      const phone = this.sanitizePhone(this.enterprisePhone);
      if (!phone) return;

      // Mesmo padrão do footer: wa.me com DDI 55
      const url = `https://wa.me/55${phone}`;
      window.open(url, "_blank", "noopener,noreferrer");
    },
  },
  mounted() {
    this.getEnterpriseData();
  },
};
</script>

<style>
/* ========================================= */
/* LANDING PAGE SÊNIOR SHOPPING - ISOLADO   */
/* ========================================= */

.landing-page-senior {
  --azul-inst: #163c53;
  --dourado: #cba34b;
  --bege-fundo: #f1e9d4;
  --verde-saude: #82a097;
  --azul-claro: #4a6faf;
  --branco: #ffffff;
  
  margin: 0 !important;
  padding: 0 !important;
  font-family: 'Mulish', sans-serif !important;
  color: var(--azul-inst) !important;
  background-color: var(--bege-fundo) !important;
  overflow-x: hidden !important;
  scroll-behavior: smooth !important;
}

.landing-page-senior h1,
.landing-page-senior h2,
.landing-page-senior h3 {
  font-family: 'Lora', serif !important;
  font-weight: 400 !important;
  margin: 0 !important;
  line-height: 1.1 !important;
}

/* --- HEADER --- */
.senior-header {
  position: absolute !important;
  top: 0 !important;
  width: 100% !important;
  padding: 10px 5% !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  background: rgba(241, 233, 212, 0.5) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  z-index: 1000 !important;
  box-sizing: border-box !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4) !important;
  height: 130px !important;
}

.senior-header .logo-container {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

.senior-header .logo-img {
  height: 110px !important;
  width: auto !important;
  display: block !important;
  filter: drop-shadow(0 4px 6px rgba(255, 255, 255, 0.8)) !important;
}

.senior-header nav {
  display: flex !important;
  align-items: center !important;
}

.senior-header nav a {
  text-decoration: none !important;
  color: var(--azul-inst) !important;
  font-weight: 800 !important;
  margin-left: 30px !important;
  font-size: 0.9rem !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
  position: relative !important;
}

.senior-header nav a::after {
  content: '' !important;
  position: absolute !important;
  width: 0 !important;
  height: 2px !important;
  bottom: -5px !important;
  left: 0 !important;
  background-color: var(--dourado) !important;
  transition: 0.3s !important;
}

.senior-header nav a:hover::after {
  width: 100% !important;
}

.senior-header .btn-nav {
  border: 2px solid var(--azul-inst) !important;
  color: var(--azul-inst) !important;
  padding: 10px 30px !important;
  border-radius: 50px !important;
  transition: 0.3s !important;
}

.senior-header .btn-nav:hover {
  background: var(--azul-inst) !important;
  color: #fff !important;
}

/* --- HERO --- */
.senior-parallax-hero {
  background-image: url('@/assets/images/imagem-hero.jpg') !important;
  background-attachment: fixed !important;
  background-position: center 80px !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  text-align: center !important;
  color: var(--azul-inst) !important;
  background-color: var(--bege-fundo) !important;
}

.senior-overlay {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: linear-gradient(
    to bottom,
    rgba(241, 233, 212, 0.4) 0%,
    rgba(241, 233, 212, 0.6) 50%,
    rgba(241, 233, 212, 0.8) 100%
  ) !important;
}

.senior-hero-content {
  position: relative !important;
  z-index: 2 !important;
  max-width: 1000px !important;
  padding: 0 20px !important;
  margin-top: 320px !important;
  animation: fadeUp 1.5s ease-out !important;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.senior-hero-content h1 {
  font-size: 5rem !important;
  margin-bottom: 20px !important;
  letter-spacing: -2px !important;
  line-height: 1 !important;
  text-shadow: 0 2px 10px rgba(255, 255, 255, 0.5) !important;
}

.senior-hero-content p {
  font-size: 1.5rem !important;
  font-weight: 500 !important;
  margin-bottom: 40px !important;
  opacity: 1 !important;
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(5px) !important;
  display: inline-block !important;
  padding: 15px 30px !important;
  border-radius: 50px !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05) !important;
  white-space: nowrap !important; /* ✅ Mantém texto em uma linha no desktop */
}

.landing-page-senior .btn-cta {
  background-color: var(--azul-inst) !important;
  color: #fff !important;
  padding: 20px 50px !important;
  font-size: 1rem !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 2px !important;
  border-radius: 50px !important;
  text-decoration: none !important;
  transition: 0.3s !important;
  display: inline-block !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}

.landing-page-senior .btn-cta:hover {
  transform: translateY(-5px) !important;
  background-color: var(--dourado) !important;
  color: var(--azul-inst) !important;
}

/* --- INTRO SECTION --- */
.senior-intro-section {
  padding: 120px 10% !important;
  text-align: center !important;
  background: var(--bege-fundo) !important;
}

.senior-intro-section h2 {
  font-size: 3.5rem !important;
  color: var(--azul-inst) !important;
  margin-bottom: 30px !important;
}

.senior-intro-section p {
  font-size: 1.3rem !important;
  line-height: 1.8 !important;
  color: var(--azul-inst) !important;
  max-width: 800px !important;
  margin: 0 auto !important;
  opacity: 0.8 !important;
}

/* --- PARALLAX DIVIDER --- */
.senior-parallax-divider {
  background-image: url('@/assets/images/imagem-meio.jpg') !important;
  background-attachment: fixed !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  min-height: 60vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  padding-top: 40px !important;
  padding-bottom: 120px !important;
}

.senior-glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px) !important;
  padding: 40px 30px !important;
  max-width: 650px !important;
  margin: 0 20px !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
  border-top: 6px solid var(--dourado) !important;
  text-align: center !important;
}

.senior-security-icon {
  font-size: 40px !important;
  color: var(--azul-inst) !important;
  margin-bottom: 20px !important;
  background: var(--bege-fundo) !important;
  width: 80px !important;
  height: 80px !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.senior-glass-card h3 {
  font-size: 2.2rem !important;
  margin-bottom: 15px !important;
  color: var(--azul-inst) !important;
}

.senior-glass-card p {
  font-size: 1.2rem !important;
  line-height: 1.5 !important;
  color: var(--azul-inst) !important;
  opacity: 0.9 !important;
}

/* --- SERVICES SECTION --- */
.senior-services-section {
  background: #fff !important;
  padding-bottom: 100px !important;
}

.senior-cards-wrapper {
  max-width: 1200px !important;
  margin: -60px auto 0 !important;
  padding: 0 20px !important;
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)) !important;
  gap: 40px !important;
  position: relative !important;
  z-index: 10 !important;
}

.senior-service-card {
  background: var(--bege-fundo) !important;
  padding: 40px 30px !important;
  transition: 0.4s !important;
  border: 1px solid rgba(0, 0, 0, 0.03) !important;
  text-align: left !important;
}

.senior-service-card:hover {
  transform: translateY(-10px) !important;
  background: #fff !important;
  box-shadow: 0 30px 50px rgba(22, 60, 83, 0.1) !important;
}

.senior-icon-box {
  font-size: 45px !important;
  margin-bottom: 20px !important;
  display: inline-block !important;
}

.senior-service-card h3 {
  font-size: 1.8rem !important;
  margin-bottom: 10px !important;
  color: var(--azul-inst) !important;
}

.senior-service-card p {
  font-size: 1rem !important;
  line-height: 1.6 !important;
  opacity: 0.8 !important;
}

/* --- FOOTER --- */
.senior-footer {
  background: var(--azul-inst) !important;
  color: #fff !important;
  padding: 100px 5% !important;
  text-align: center !important;
}

.senior-footer h2 {
  font-size: 3rem !important;
  color: var(--dourado) !important;
  margin-bottom: 20px !important;
}

.senior-footer-links {
  margin-top: 40px !important;
  opacity: 0.6 !important;
  font-size: 0.9rem !important;
}

/* Botão específico do footer (branco) */
.senior-btn-footer {
  background-color: #fff !important;
  color: var(--azul-inst) !important;
  padding: 20px 50px !important;
  font-size: 1rem !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 2px !important;
  border-radius: 50px !important;
  text-decoration: none !important;
  transition: 0.3s !important;
  display: inline-block !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}

.senior-btn-footer:hover {
  transform: translateY(-5px) !important;
  background-color: #fff !important;
  color: var(--azul-inst) !important;
}

/* --- PRICING SECTION --- */
.senior-pricing-section {
  background: #fff !important;
  padding: 120px 10% 110px !important;
  position: relative !important;
  overflow: hidden !important;
}

.senior-pricing-header {
  text-align: center !important;
  max-width: 900px !important;
  margin: 0 auto 60px !important;
}

.senior-pricing-header h2 {
  font-size: 3.2rem !important;
  color: var(--azul-inst) !important;
  margin-bottom: 18px !important;
}

.senior-pricing-header p {
  font-size: 1.2rem !important;
  line-height: 1.7 !important;
  color: var(--azul-inst) !important;
  opacity: 0.85 !important;
  margin: 0 auto !important;
}

.senior-pricing-grid {
  max-width: 1200px !important;
  margin: 0 auto !important;
  display: grid !important;
  grid-template-columns: repeat(3, minmax(260px, 1fr)) !important;
  gap: 28px !important;
  align-items: stretch !important;
}

.senior-plan-card {
  background: var(--bege-fundo) !important;
  padding: 34px 28px !important;
  transition: 0.35s !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
}

.senior-plan-card:hover {
  transform: translateY(-8px) !important;
  background: #fff !important;
  box-shadow: 0 30px 60px rgba(22, 60, 83, 0.12) !important;
}

.senior-plan-top {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
  gap: 12px !important;
  margin-bottom: 14px !important;
}

.senior-plan-name {
  font-family: 'Lora', serif !important;
  font-size: 1.8rem !important;
  color: var(--azul-inst) !important;
  line-height: 1.1 !important;
}

.senior-badge {
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
  padding: 8px 12px !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.65) !important;
  backdrop-filter: blur(8px) !important;
}

.senior-badge-best {
  border-color: rgba(203, 163, 75, 0.45) !important;
  background: rgba(203, 163, 75, 0.15) !important;
  color: var(--azul-inst) !important;
}

.senior-price-line {
  margin: 10px 0 6px !important;
  color: var(--azul-inst) !important;
  display: flex !important;
  align-items: baseline !important;
  gap: 10px !important;
  flex-wrap: wrap !important;
}

.senior-price-main {
  font-size: 2.3rem !important;
  font-weight: 900 !important;
  letter-spacing: -1px !important;
}

.senior-price-suffix {
  font-size: 1rem !important;
  opacity: 0.85 !important;
  font-weight: 700 !important;
}

.senior-total-line {
  font-size: 0.98rem !important;
  opacity: 0.85 !important;
  margin-bottom: 18px !important;
}

.senior-total-pill {
  display: inline-block !important;
  padding: 8px 12px !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.7) !important;
}

.senior-save-line {
  font-size: 0.98rem !important;
  margin-top: 10px !important;
  opacity: 0.9 !important;
}

.senior-strike {
  text-decoration: line-through !important;
  opacity: 0.7 !important;
  margin-left: 6px !important;
}

.senior-plan-features {
  list-style: none !important;
  padding: 0 !important;
  margin: 18px 0 26px !important;
  display: grid !important;
  gap: 12px !important;
}

.senior-plan-features li {
  display: flex !important;
  gap: 10px !important;
  align-items: flex-start !important;
  font-size: 1rem !important;
  line-height: 1.4 !important;
  color: var(--azul-inst) !important;
  opacity: 0.9 !important;
}

.senior-plan-features i {
  margin-top: 2px !important;
  color: var(--dourado) !important;
}

.senior-plan-cta {
  display: block !important;
  text-align: center !important;
  text-decoration: none !important;
  font-weight: 900 !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
  padding: 16px 18px !important;
  border-radius: 999px !important;
  border: 2px solid var(--azul-inst) !important;
  color: var(--azul-inst) !important;
  transition: 0.25s !important;
  margin-top: auto !important;
}

.senior-plan-cta:hover {
  background: var(--azul-inst) !important;
  color: #fff !important;
}

.senior-best {
  border-top: 8px solid var(--dourado) !important;
  background: rgba(241, 233, 212, 0.75) !important;
}

.senior-best .senior-plan-cta {
  background: var(--azul-inst) !important;
  color: #fff !important;
  border-color: var(--azul-inst) !important;
}

.senior-best .senior-plan-cta:hover {
  background: var(--dourado) !important;
  color: var(--azul-inst) !important;
  border-color: var(--dourado) !important;
}

.senior-pricing-note {
  max-width: 1000px !important;
  margin: 40px auto 0 !important;
  padding: 22px 22px !important;
  background: rgba(241, 233, 212, 0.55) !important;
  font-size: 1rem !important;
  line-height: 1.6 !important;
  color: var(--azul-inst) !important;
  opacity: 0.9 !important;
}

/* ========================================= */
/* MOBILE RESPONSIVO                        */
/* ========================================= */

@media (max-width: 768px) {
  .senior-header {
    position: absolute !important;
    height: auto !important;
    flex-direction: column !important;
    padding: 15px 5% !important;
    background: rgba(241, 233, 212, 0.95) !important;
    border-bottom: 1px solid #cba34b !important;
    gap: 10px !important;
  }

  .senior-header .logo-img {
    height: 100px !important;
  }

  .senior-header nav {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 15px !important;
    width: 100% !important;
    margin-top: 5px !important;
  }

  .senior-header nav a {
    margin-left: 0 !important;
    font-size: 0.85rem !important;
  }

  .senior-header .btn-nav {
    padding: 8px 20px !important;
    font-size: 0.85rem !important;
  }

  .senior-parallax-hero {
    background-attachment: scroll !important;
    background-position: center 140px !important;
    height: auto !important;
    min-height: 100vh !important;
    padding-bottom: 50px !important;
    background-color: var(--bege-fundo) !important;
  }

  .senior-hero-content {
    margin-top: 240px !important;
    padding: 0 15px !important;
  }

  .senior-hero-content h1 {
    font-size: 3rem !important;
    margin-bottom: 15px !important;
  }

  .senior-hero-content p {
    font-size: 1.1rem !important;
    padding: 10px 15px !important;
    white-space: normal !important; /* ✅ Permite quebra de linha no mobile */
  }

  .landing-page-senior .btn-cta {
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 18px 0 !important;
  }

  .senior-btn-footer {
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 18px 0 !important;
  }

  .senior-intro-section {
    padding: 60px 5% !important;
  }

  .senior-intro-section h2 {
    font-size: 2.2rem !important;
  }

  .senior-parallax-divider {
    background-attachment: scroll !important;
    padding: 60px 0 !important;
  }

  .senior-glass-card {
    margin: 15px !important;
    padding: 30px 20px !important;
  }

  .senior-glass-card h3 {
    font-size: 1.8rem !important;
  }

  .senior-cards-wrapper {
    margin-top: 0 !important;
    padding-top: 50px !important;
    gap: 30px !important;
  }

  .senior-pricing-grid {
    grid-template-columns: 1fr !important;
  }

  .senior-pricing-section {
    padding: 60px 5% 60px !important;
  }

  .senior-pricing-header {
    margin-bottom: 35px !important;
  }

  .senior-pricing-header h2 {
    font-size: 2.05rem !important;
    line-height: 1.12 !important;
  }

  .senior-pricing-header p {
    font-size: 1.05rem !important;
    line-height: 1.6 !important;
  }

  .senior-plan-card {
    padding: 28px 22px !important;
  }

  .senior-plan-name {
    font-size: 1.55rem !important;
  }

  .senior-price-main {
    font-size: 2rem !important;
  }

  .senior-price-suffix {
    font-size: 0.95rem !important;
  }

  .senior-plan-features li {
    font-size: 0.98rem !important;
  }

  .senior-plan-cta {
    padding: 15px 16px !important;
  }

  .senior-pricing-note {
    font-size: 0.98rem !important;
  }
}

@media (min-width: 768px) and (max-width: 980px) {
  .senior-pricing-section {
    padding: 70px 5% 70px !important;
  }

  .senior-pricing-header h2 {
    font-size: 2.3rem !important;
  }

  .senior-price-main {
    font-size: 2.1rem !important;
  }
}
</style>
